var InMemoryStore =
/** @class */
function () {
  function InMemoryStore() {
    var _this = this;

    this._data = {};
    this.length = 0;

    this.setItem = function (key, value) {
      _this._data[key] = value;
      _this.length = Object.keys(_this._data).length;
      return value;
    };

    this.getItem = function (key) {
      if (key in _this._data) {
        return _this._data[key];
      }

      return null;
    };

    this.removeItem = function (key) {
      if (key in _this._data) {
        delete _this._data[key];
      }

      _this.length = Object.keys(_this._data).length;
      return null;
    };

    this.clear = function () {
      _this._data = {};
      _this.length = 0;
    };

    this.key = function (index) {
      return Object.keys(_this._data)[index];
    };
  }

  return InMemoryStore;
}();

export { InMemoryStore };
export default new InMemoryStore();